export const getIntialValues = (data = {}) => {
  return {
    meta_seo: {
      meta_title: data?.meta_seo?.meta_title || "",
      meta_keyword: data?.meta_seo?.meta_keyword || "",
      meta_desc: data?.meta_seo?.meta_desc || "",
    },
    header: {
      primary_heading: data?.header?.primary_heading || "",
      secondary_heading: data?.header?.secondary_heading || "",
      description: data?.header?.description || "",
      primary_cta: {
        label: data?.header?.primary_cta?.label || "",
        redirect_url: data?.header?.primary_cta?.redirect_url || "",
      },
      secondary_cta: {
        label: data?.header?.secondary_cta?.label || "",
        redirect_url: data?.header?.secondary_cta?.redirect_url || "",
      },
    },

    banners: data?.banners?.length ? data.banners : [{ title: "", description: "", details: "", icon: "", desktop_image_url: "" , alt_tag:"",}],

    section_add_ons: {
      title: data?.section_add_ons?.title || "",
      description: data?.section_add_ons?.description || "",
      add_ons: data?.section_add_ons?.add_ons?.length ? data.section_add_ons.add_ons : [{ image_url: "", alt_tag: "" }],
    },

    multi_cards_section: data?.multi_cards_section?.length
      ? data.multi_cards_section
      : [{ title: "", secondary_title: "", description: "", details: "", icon: "", desktop_image_url: "" , alt_tag:"", }],

    testimonials: {
      heading: data?.testimonials?.heading || "",
      testimonials: data?.testimonials?.testimonials || [{ faq: "" }],
    },
  };
};

export const generatePayload = (values) => {
  return {
    meta_seo: {
      meta_title: values?.meta_seo?.meta_title || "",
      meta_keyword: values?.meta_seo?.meta_keyword || "",
      meta_desc: values?.meta_seo?.meta_desc || "",
    },
    header: {
      primary_heading: values?.header?.primary_heading || "",
      secondary_heading: values?.header?.secondary_heading || "",
      description: values?.header?.description || "",
      primary_cta: {
        label: values?.header?.primary_cta?.label || "",
        redirect_url: values?.header?.primary_cta?.redirect_url || "",
      },
      secondary_cta: {
        label: values?.header?.secondary_cta?.label || "",
        redirect_url: values?.header?.secondary_cta?.redirect_url || "",
      },
    },

    banners: values?.banners?.length ? values.banners : [{ title: "", description: "", details: "", icon: "", desktop_image_url: "" , alt_tag:"",}],

    section_add_ons: {
      title: values?.section_add_ons?.title || "",
      description: values?.section_add_ons?.description || "",
      add_ons: values?.section_add_ons?.add_ons?.length ? values.section_add_ons.add_ons : [{ image_url: "", alt_tag: "" }],
    },
    multi_cards_section: values?.multi_cards_section?.length
      ? values.multi_cards_section
      : [{ title: "", secondary_title: "", description: "", details: "", icon: "", desktop_image_url: "" , alt_tag:"",}],

    testimonials: {
      heading: values?.testimonials?.heading || "",
      testimonials: values?.testimonials?.testimonials || [{ faq: "" }],
    },
  };
};
